import { useSelector } from 'react-redux';
import { selectSignUpState } from '../signUpSlice';

export const useSignupData = () => useSelector(selectSignUpState);
